import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useAppContext } from '../Context';
import { useTranslation } from '../TranslationContext';

function Choices() {
	const [data, setData] = useState([]);
	const { psServer, fullfilment, submittedCode, setPackageChoice, setSelectedItems, currencySymbol, allowPurchase, onlineOnly, clickedImage } = useAppContext();
	const { t, language } = useTranslation();
	const method = fullfilment === 'Y' ? 'fulfilment' : 'digital/' + submittedCode;
	const navigate = useNavigate();
	
	useEffect(() => {
		const fetchData = async () => {
			try {
				let url = `${psServer}/ui/options/${method}`;
				const response = await fetch(url, {
					method: 'GET',
					headers: {
						'Content-Type': 'application/json',
					}
				});
				const jsonData = await response.json();
				setData(jsonData);
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		};
		fetchData();
	}, [method, submittedCode]);
	
	function convertLineBreaks(textToConvert) {
		const lines = textToConvert.split('\n');
		return (
			<div>
				{lines.map((line, index) => (
					<p key={index}>{line}</p>
				))}
			</div>
		);
	}
	
	function handleClick(item) {
		//setPackageChoice([event.target.id, itemName, itemDescription, itemPrice]);
		setPackageChoice(item);
		setSelectedItems({});
		if (method === "getPurchaseOptions") {
			navigate('/select');
		} else {
			navigate('/checkout');
		}
	}
	
	return (
		<>
			{allowPurchase ? (
				<motion.div
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					transition={{ duration: 0.5, ease: "easeInOut" }}
					className="container"
				>
				{data.map((item, index) => (
					<motion.div
						whileHover={{ scale: 1.1 }}
						whileTap={{ 
							scale: 0.9, 
							transition: { duration: 0.5 }
						}}
						className="item"
						id={item.id}
						key={index}
						style={{ backgroundColor: item.colour }}
						onTap={(event) => {
							handleClick(item);
						}}
					>
						<h1>{JSON.parse(item.name)[language]}</h1>
						<div className="choiceInfo">{convertLineBreaks(JSON.parse(item.description)[language])}</div>
						<h1>{currencySymbol()}{(item.incVat/100)}</h1>
					</motion.div>
				))}
				</motion.div>
			) : (
				<div className="paymentMessage">
					<motion.div
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						transition={{ duration: 0.5, ease: "easeInOut" }}
					>
						Page Expired...
					</motion.div>
				</div>
			)}
		</>
	);
}

export default Choices;